import { createStore } from 'effector'

export interface TransferPolicy {
  id: number
  mode: string
  allowedCountries: string[]
  createdAt: string
  updatedAt: string
}

export const $transferPolicy = createStore<TransferPolicy | null>(null)
export const $transferPolicyLoading = createStore<boolean>(false)
